import useWindowSize from "./useWindowSize"
import FoundationVariables from "../../Styles/Fondprodukter/variables/_foundation.scss"
import useParseCssList from "./useParseCssList"
import React from "react";

const breakpoints = useParseCssList(FoundationVariables.breakpoints);
const mediumBreakpoint = parseInt(breakpoints.medium.replace("px", ""))

export default function useIsMobile() {
  const [windowWidth] = useWindowSize()
  const [isMobile, setIsMobile] = React.useState(windowWidth <= mediumBreakpoint-1)
  React.useEffect(() => {
      setIsMobile(windowWidth <= mediumBreakpoint-1)
  }, [windowWidth])
  return isMobile
}